import { render, staticRenderFns } from "./EditInternalPromo.vue?vue&type=template&id=1b55d7c6"
import script from "./EditInternalPromo.vue?vue&type=script&lang=js"
export * from "./EditInternalPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports